import { render, staticRenderFns } from "./ChooseJobType.vue?vue&type=template&id=bb705504&scoped=true"
import script from "./ChooseJobType.vue?vue&type=script&lang=js"
export * from "./ChooseJobType.vue?vue&type=script&lang=js"
import style0 from "./ChooseJobType.vue?vue&type=style&index=0&id=bb705504&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb705504",
  null
  
)

export default component.exports